import React, { ReactChildren } from "react";

function Aux({ children }: { children: ReactChildren }) {
  return <React.Fragment>{children}</React.Fragment>;
}

export default Aux;
